import { Endpoint } from '@/types/api.type.ts';

export const reportEndpoints: Endpoint[] = [
    {
        name: 'GetBidReportByAuction',
        method: 'get',
        path: '/reports/report-by-bids-in-lots/:id',
    },
    {
        name: 'GetBidReportByAuctionFile',
        method: 'get',
        path: '/reports/report-by-bids-in-lots/:id/report',
    },
    {
        name: 'GetBidReportAuctions',
        method: 'get',
        path: '/reports/report-by-bids-in-lots',
    },
    {
        name: 'GetBidReportAuctionsFile',
        method: 'get',
        path: '/reports/report-by-bids-in-lots/report',
    },
    {
        name: 'GetCarsPostingAndSellingReports',
        method: 'get',
        path: '/reports/cars-posting-and-selling',
    },
    {
        name: 'GetCarsPostingAndSellingReportFile',
        method: 'get',
        path: '/reports/cars-posting-and-selling/:id',
    },
    {
        name: 'RegenerateCarsPostingAndSellingReport',
        method: 'patch',
        path: '/reports/cars-posting-and-selling/:id',
    },
    {
        name: 'GetAccountingReportFile',
        method: 'get',
        path: '/reports/accounting/report',
    },
    {
        name: 'GetAuctionsReportFile',
        method: 'get',
        path: '/reports/auctions-report/report',
    },
];

